import { render, staticRenderFns } from "./ListSeatingChart.vue?vue&type=template&id=681b9b4c&scoped=true&"
import script from "./ListSeatingChart.vue?vue&type=script&lang=js&"
export * from "./ListSeatingChart.vue?vue&type=script&lang=js&"
import style0 from "./ListSeatingChart.vue?vue&type=style&index=0&id=681b9b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b9b4c",
  null
  
)

export default component.exports